/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {AbbreviationPipe} from './abbreviation.pipe';
import {AlertNumberPipe} from './alert-number.pipe';
import {BypassSecurityTrustHtmlPipe} from './bypass-security-trust-html.pipe';
import {BypassSecurityTrustUrlPipe} from './bypass-security-trust-url.pipe';
import {ByteConverterPipe} from './byte-converter.pipe';
import {CalendarArrayNumberPipe} from './calendar-array-number.pips';
import {CalendarDateRangePipe} from './calendar-date-range.pipe';
import {CalendarOrdinalPipe} from './calendar-ordinal.pipe';
import {ContainsPipe} from './contains.pipe';
import {DateInfinityPipe} from './date-infinity.pipe';
import {DateLocalizationPipe} from './date-localization.pipe';
import {DayOfWeekPipe} from './day-of-week.pipe';
import {DebugTypePipe} from './debug-type.pipe';
import {DisplayFilePipe} from './display-file.pipe';
import {DumpPipe} from './dump.pipe';
import {EventIdPipe} from './event-id.pipe';
import {GpTestIdPipe} from './gp-test-id.pipe';
import {HtmlToTextPipe} from './html-to-text';
import {InitialsPipe} from './initials.pipe';
import {NumberFormatPipe} from './number.pipe';
import {NumericFieldTypePipe} from './numeric-field-type.pipe';
import {KeysPipe} from './object-keys.pipe';
import {PayIdPipe} from './pay-id.pipe';
import {SortPipe} from './sort.pipe';
import {SortByTranslationsPipe} from './sortByTranslations.pipe';
import {TimezoneOffsetPipe} from './timezone-offset.pipe';
import {TranslateAndFormatVariablesPipe} from './translate-and-format-variables.pipe';
import {TwoLetters} from './two-letters.pipe';

import {GetTransIdsDisplayPipe} from '../localization/translate-trans-ids.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ContainsPipe,
    DebugTypePipe,
    DumpPipe,
    KeysPipe,
    SortPipe,
    SortByTranslationsPipe,
    TimezoneOffsetPipe,
    PayIdPipe,
    EventIdPipe,
    BypassSecurityTrustUrlPipe,
    TwoLetters,
    InitialsPipe,
    AbbreviationPipe,
    NumberFormatPipe,
    DateLocalizationPipe,
    HtmlToTextPipe,
    AlertNumberPipe,
    CalendarDateRangePipe,
    CalendarOrdinalPipe,
    CalendarArrayNumberPipe,
    DayOfWeekPipe,
    ByteConverterPipe,
    BypassSecurityTrustHtmlPipe,
    GpTestIdPipe,
    GetTransIdsDisplayPipe,
    TranslateAndFormatVariablesPipe,
    DateInfinityPipe,
    DisplayFilePipe,
    NumericFieldTypePipe
  ],
  exports: [
    ContainsPipe,
    DebugTypePipe,
    DumpPipe,
    KeysPipe,
    SortPipe,
    SortByTranslationsPipe,
    TimezoneOffsetPipe,
    PayIdPipe,
    EventIdPipe,
    BypassSecurityTrustUrlPipe,
    TwoLetters,
    InitialsPipe,
    AbbreviationPipe,
    NumberFormatPipe,
    DateLocalizationPipe,
    HtmlToTextPipe,
    AlertNumberPipe,
    CalendarDateRangePipe,
    CalendarOrdinalPipe,
    CalendarArrayNumberPipe,
    DayOfWeekPipe,
    ByteConverterPipe,
    BypassSecurityTrustHtmlPipe,
    GpTestIdPipe,
    GetTransIdsDisplayPipe,
    TranslateAndFormatVariablesPipe,
    DateInfinityPipe,
    DisplayFilePipe,
    NumericFieldTypePipe
  ],
  providers: []
})
export class PipesModule {
}
